<template>
    <div class="container-top" v-loading.fullscreen.lock="loading"
         :class="{'has-child' : $route.meta.isChild}"
    >
        <router-view/>
        <menu-modal></menu-modal>

    </div>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue'
import EventBus from "@/utils/event-bus";
import pageFooter from "@/components/PageFooter.vue";
import MenuModal from "@/components/modal/MenuModal.vue";
import MobileDetect from "mobile-detect";
import {isDev, isBeta, isCbt} from "@/api/config";

export default {
    name: "App",
    mixins: [],
    components: {
        MenuModal,
        pageFooter,
        PageHeader,
    },
    provide() {
        return {
            changeLoading: this.changeLoading,
        }
    },
    props: {},
    data() {
        return {
            passPath: ['/auth'],
            loading: false,
            loadingText: '',
        }
    },
    created() {
        const md = new MobileDetect(window.navigator.userAgent);
        // iPadOS 13+ Safari는 데스크톱 모드에서 Macintosh로 식별된다.
        const isPad = navigator.maxTouchPoints > 1 && /MacIntel/.test(navigator.platform);
        
        if (md.mobile() == null && md.tablet() == null && !isPad)  {
            // 약관 단독 페이지는 외부(카카오 동의창 등)에서 직접 열리므로 경로를 보존해 전환한다
            const path = location.pathname.startsWith('/auth/register/terms/') ? location.pathname : '/';
            if (isCbt) {
                location.href = 'https://cbt.cmbrainbowtv.co.kr' + path
            } else if (isBeta) {
                location.href = 'https://beta.cmbrainbowtv.co.kr' + path
            } else if (isDev) {
                location.href = 'https://dev.cmbrainbowtv.co.kr' + path
            } else {
                location.href = 'https://www.cmbrainbowtv.co.kr' + path
            }
        }
    },
    mounted() {
        EventBus.$on('changeLoading', this.changeLoading);
        EventBus.$on('apiLoading', this.changeLoading);
        EventBus.$on('apiLoadingProgress', this.changeLoadingProgress);
        EventBus.$on('moveTop', this.moveTop);
        this.$vfm.show('membership-modal');
    },
    beforeUnmount() {
        EventBus.$off('changeLoading')
        EventBus.$off('apiLoading')
        EventBus.$off('apiLoadingProgress')
        EventBus.$off('moveTop');
    },
    destroyed() {
    },
    computed: {},
    methods: {
        moveTop() {
            $('html').animate({
                scrollTop: 0
            }, 300);
        },


        changeLoading(value, text = '') {
            this.loading = value;
            if (!value) {
                this.loadingText = '';
            } else {
                this.loadingText = text;
            }
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve(true);
                }, 50)
            })
        },

    },
    watch: {},
}
</script>

<style lang="scss">
@import "./assets/scss/index.scss";

</style>
